import {
  SET_LIST_ICON,
  SET_ICON_GALLERIES
} from '@/store/mutation-types'
export default {
  [SET_LIST_ICON] (state, icons) {
    state.icons = icons
  },
  [SET_ICON_GALLERIES] (state, data) {
    state.iconGalleries = data
    this._vm.$eventBus.$emit('iconsFetched')
  },
  'SET_ICONS_FETCHED' (state, value) {
    state.iconsFetched = value
  }
}



// WEBPACK FOOTER //
// ./src/components/icon/store/mutations.js